var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

(function (Cobalt) {
    var Tidbit = /** @class */ (function () {
        function Tidbit() {
        }
        Tidbit.initialize = function () {
            this.ListingComments = $('ul.listing-comments');
            this.BindEvents();
        };
        Tidbit.BindEvents = function () {
            this.ListingComments.delegate('ul.p-comment-stats li:last-child', 'click', this.getEventHandler('memberDetailsClick'));
        };
        Tidbit.getEventHandler = function (event) {
            var _this = this;
            if (event && this.EventHandlers[event] !== undefined) {
                return function () {
                    var args = Array.prototype.slice.call(arguments, 0);
                    args.unshift($(this));
                    _this.EventHandlers[event].apply(_this, args);
                };
            }
        };
        return Tidbit;
    }());
    Cobalt.Tidbit = Tidbit;
    (function (Tidbit) {
        var EventHandlers = /** @class */ (function (_super) {
            __extends(EventHandlers, _super);
            function EventHandlers() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            EventHandlers.memberDetailsClick = function ($this, event) {
                if (window.innerWidth <= 640) {
                    $this.parent().toggleClass('open');
                }
            };
            return EventHandlers;
        }(Tidbit));
        Tidbit.EventHandlers = EventHandlers;
    })(Tidbit = Cobalt.Tidbit || (Cobalt.Tidbit = {}));
})(Cobalt || (window.Cobalt = {}));


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Tidbit.js